import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { tap } from "rxjs/operators";
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: "root",
})
export class AppVersionService {
    private http = inject(HttpClient);

    versionCache: string | null = null;

    constructor() {}

    getVersion(): Observable<string> {
        let versionObservable: Observable<string>;

        if (this.versionCache !== null) {
            versionObservable = of(this.versionCache);
        } else if (
            /localhost/.test(document.location.host) ||
            /taxprepdashboard.dev-local.ca/.test(document.location.host) ||
            /dev-local.taxprepdashboard.ca/.test(document.location.host)
        ) {
            this.versionCache = environment.version;
            versionObservable = of(this.versionCache);
        } else {
            const url = "/version.txt";

            versionObservable = this.http.get(url, { responseType: "text" }).pipe(
                tap((data: string) => {
                    this.versionCache = data;
                }),
            );
        }

        return versionObservable;
    }
}
